var AdaptiveImage = require("../node_modules/react-native-web-image-loader/lib/modules/adaptiveImage.js").default;

module.exports = new AdaptiveImage({
    uri: __webpack_public_path__ + "icon-add-role.adb82fc6.png","uri@2x": __webpack_public_path__ + "icon-add-role.44a7bdc6.png","uri@3x": __webpack_public_path__ + "icon-add-role.8f1ef3bd.png",
    width: 64,
    height: 51
});